
import React from 'react';
import { FormattedInstagramPost } from '@/utils/instagram';
import InstagramPostCard from './InstagramPostCard';

interface InstagramGridProps {
  posts: FormattedInstagramPost[];
  inView: boolean;
}

const InstagramGrid: React.FC<InstagramGridProps> = ({ posts, inView }) => {
  return (
    <div 
      className={`grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-1 md:gap-3 ${
        inView ? 'opacity-100 translate-y-0 transition-all duration-700 delay-200' : 'opacity-0 translate-y-10 transition-all duration-700'
      }`}
    >
      {posts.map((post, index) => (
        <InstagramPostCard key={post.id} post={post} index={index} />
      ))}
    </div>
  );
};

export default InstagramGrid;
